import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta-plus",
  "use": "icon-arrow--cta-plus-usage",
  "viewBox": "0 0 10 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 9\" id=\"icon-arrow--cta-plus\"><path d=\"M1 4.952V4.07h3.496V.5h1.008v3.57H9v.882H5.504V8.5H4.496V4.952H1Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol